<script>
import InlineSVG from 'svelte-inline-svg'
import { providers } from '../common'

let usmapPath = '/img/us-map-with-cities.svg' // edit with https://www.vecteezy.com/editor
let title = "About Steer"

</script>
<section>
  <div class="section-body">

    <div classA="row">
      <div classA="col-lg-8">

        <h2 class="ioreveal animate__animated" data-anicss="animate__fadeInUp">{title}</h2>

          <div class="fact-box">
            <p class="leading ioreveal animate__animated animate__delay-1s" style="animation-delay: .2s;" data-anicss="animate__fadeInUp">
           <a href="https://www.steergroup.com/sectors/new-mobility " target="_blank">Steer's New Mobility team</a> has significant experience helping local government and private sector operators to plan for, develop and implement new transport technologies across North America and Europe.
            </p>
            <div class="ioreveal animate__animated animate__delay-1s" style="animation-delay: .4s;" data-anicss="animate__fadeInUp">
              Our key experience and expertise focuses on:
              <ul class="ioreveal animate__animated animate__delay-1s" style="animation-delay: .5s;" data-anicss="animate__fadeInUp">
                <li>Shared Mobility;</li>
                <li>Zero Emission Vehicles;  and </li>
                <li>Emerging Services, such as Mobility-as-as Service, Mobility Hubs and autonomous services.</li>
              </ul>
            </div>
            <p class="ioreveal animate__animated animate__delay-1s" style="animation-delay: .7s;" data-anicss="animate__fadeInUp">
            Our expertise is based on a deep understanding of the factors which help or hinder the adoption of new transport modes; and monitoring and evaluation of new services enable us to build an evidence base to inform planning and implementation of new mobility solutions.
            </p>
            <p class="ioreveal animate__animated animate__delay-1s" style="animation-delay: .8s;" data-anicss="animate__fadeInUp">
            Our experience includes planning and feasibility studies, procurement advice, bid support,
            monitoring and evaluation, and impact assessment.
            </p>
            <p class="ioreveal animate__animated animate__delay-1s" style="animation-delay: .9s;" data-anicss="animate__fadeInUp">
            Steer has supported the launch and development of bike sharing and shared micromobility solutions in cities across the world, working with regional and local authorities and micromobility operators.<br>
            </p>
            <p class="text-strong ioreveal animate__animated animate__delay-1s" style="animation-delay: 1s;" data-anicss="animate__fadeInUp">
              For more information, please contact: <br>
              <strong>Alia Verloes, Steer</strong> <br>
              <a href="mailto:alia.verloes@steergroup.com">alia.verloes@steergroup.com</a> <br>
              <a href="tel:+16469899948">+1 646 989 9948</a> <br>
            </p>
          </div>

      </div>
    </div>
    <br><br>
    <h4 class="ioreveal animate__animated animate__delay-1s" style="animation-delay: .1s;" data-anicss="animate__fadeIn">
      <strong>Recent projects</strong>
    </h4>
    <div class="row ioreveal animate__animated animate__delay-1s" style="animation-delay: .2s;" data-anicss="animate__fadeIn">
      <div class="col-md-4 col-lg-4 col-xl-4">
        <a target="_blank" href="https://www.steergroup.com/projects/assessing-shared-ebike-potential-london-new-york" class="project-link" style="background-image: url('https://www.steergroup.com/sites/default/files/styles/full_width/public/2019-02/uber-bike-share_hero.jpg?itok=SkfIVK_K')">
        Assessing the shared ebike potential in London and New York
        </a>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4">
        <a target="_blank" href="https://www.steergroup.com/projects/economic-impacts-autonomous-delivery-services-us" class="project-link" style="background-image: url('https://www.steergroup.com/sites/default/files/styles/full_width/public/2020-09/nuro-banner.jpg?itok=zqcBu1PY')">
        Economic impacts of autonomous delivery services in the US
        </a>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4">
        <a target="_blank" href="https://www.steergroup.com/projects/research-legal-regulatory-framework-smart-futures-transport" class="project-link" style="background-image: url('https://www.steergroup.com/sites/default/files/styles/full_width/public/2019-02/uber-bike-share_hero.jpg?itok=SkfIVK_K')">
        Research for the legal and regulatory framework for smart futures on transport
        </a>
      </div>
      <br>
      <br>
      <br>
      <br>
      &nbsp;
    </div>
  </div>
</section>

<style>
.row {
  text-align: left;
}
.section-body {
  max-width: 960px;
  padding: 30px;
  margin: auto;
  /* margin-left: 200px; */
  text-align: left;
}
p {
  line-height: 160%;
}
ul {
  margin: 0;
}
li {
  margin: 7px 0;
}
.text-strong {
  font-weight: bold;
}
.leading {
  font-size:1.2rem;
}
.project-link {
  padding: 15px;
  min-height: 120px;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  display: block;
}
a.project-link, a.project-link:link {
  color: #fff;
  text-decoration: none;
  border: solid 1px rgba(255,255,255, 0);
  transition: 0.25s;
}
a.project-link:hover {
  border: solid 1px rgba(255,255,255, 1);
  background-position: top center;
}
</style>